import { useNavigate } from 'react-router';
import { formatPickRecord, formatTies, formatWeekList } from '../../utils/predictionScorecard';

function SeasonRecordLine({ totals }) {
  if (!totals.gradedWeeks) return <p className="forecast-record__season"><span>Season record:</span> starts after the first final scores.</p>;
  const details = [];
  if (totals.tiedMatchups) details.push(formatTies(totals.tiedMatchups));
  details.push(`${totals.gradedWeeks} graded week${totals.gradedWeeks === 1 ? '' : 's'}`);
  details.push(`${totals.meanAbsoluteError.toFixed(1)} mean absolute error`);
  return <p className="forecast-record__season"><span>Season record:</span> <b>{formatPickRecord(totals)}</b> picks correct · {details.join(' · ')}</p>;
}

function pregameOnlyLine(record, lateWeeks) {
  const pregame = record?.completedWeeks ? formatPickRecord(record) : 'no graded weeks yet';
  return `Pregame editions only: ${pregame} · ${formatWeekList(lateWeeks)} ${lateWeeks.length === 1 ? 'was' : 'were'} captured after first kickoff`;
}

export default function ForecastHero({ prediction, issues, selectedIssue, record, scorecard }) {
  const navigate = useNavigate();
  const late = Boolean(prediction.editionType);
  const wednesdaySnapshot = prediction.season === 2026 && prediction.week === 6
    && prediction.editionType === 'late-2026-week-6';
  return (
    <header className="forecast-hero" id="forecast-top">
      <div className="forecast-hero__grid" aria-hidden="true" />
      <div className="forecast-shell forecast-hero__inner">
        <div className="forecast-edition">
          <span>{wednesdaySnapshot ? 'Weekly predictions' : late ? 'Late edition · after kickoff' : 'Pregame forecast'}</span>
          <span>{prediction.edition}</span>
        </div>
        <p className="forecast-kicker">Bruins09 intelligence desk</p>
        <h1 className="forecast-title">The<br /><em>Forecast</em></h1>
        <div className="forecast-hero__footer">
          <p className="forecast-subtitle">Week {prediction.week} · AI Picks</p>
          <p className="forecast-byline">From the AI behind Bruins09</p>
        </div>
        <p className="forecast-lead">Five matchups. The math is on the record.</p>
        {late && !wednesdaySnapshot && <p className="forecast-late-notice" role="note">First NFL kickoff preceded this forecast capture. This is a late edition, not a pregame forecast. It is marked late in the season scorecard and excluded only from the pregame-only record.</p>}
        <div className="forecast-asof">
          <span className="forecast-asof__dot" aria-hidden="true" />
          <span>Numbers frozen {prediction.capturedLabel}</span>
          <span className="forecast-asof__rule" aria-hidden="true" />
          <span>First kickoff {prediction.firstKickoffLabel}</span>
        </div>
        <label className="forecast-week-picker"><span>Published issue</span><select value={`${selectedIssue.season}-${selectedIssue.week}`} onChange={(event) => { const next = issues.find((issue) => `${issue.season}-${issue.week}` === event.target.value); if (next) navigate(`/ai-picks/${next.season}/week-${next.week}`); }}>{issues.map((issue) => <option key={`${issue.season}-${issue.week}`} value={`${issue.season}-${issue.week}`}>{issue.label}</option>)}</select></label>
        <div className="forecast-record">
          <SeasonRecordLine totals={scorecard.totals} />
          {scorecard.lateGradedWeeks.length > 0 && <p className="forecast-record__pregame">{pregameOnlyLine(record, scorecard.lateGradedWeeks)}</p>}
          {scorecard.rows.length > 0 && <a className="forecast-record__link" href="#forecast-season">Week-by-week scorecard <span aria-hidden="true">↓</span></a>}
        </div>
      </div>
    </header>
  );
}
